/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmd_PeekInputs */

const en_cmd_peek = /** @type {(inputs: Cmd_PeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview item`)
};

const de_cmd_peek = /** @type {(inputs: Cmd_PeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau anzeigen`)
};

/**
* | output |
* | --- |
* | "Preview item" |
*
* @param {Cmd_PeekInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cmd_peek = /** @type {((inputs?: Cmd_PeekInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmd_PeekInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cmd_peek(inputs)
	return en_cmd_peek(inputs)
});